import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { QUALITY_STATUS_NAMES } from 'Core/constants/constants';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectInspectionResultsData = state => selectState(state).data;
export const selectInspectionResultsLoading = state => selectState(state).loading;
export const selectInspectionResultsError = state => selectState(state).error;
export const selectInspectionResultsFilterVisible = state => selectState(state).filterVisible;
export const selectInspectionResultsFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectedPart = state => selectState(state).selectedInspectionResults;
export const selectInspectionResultsDeepLink = state => selectState(state).deepLink;
export const inspectionResultsData = state => selectState(state).inspectionResultsData;
export const inspectionResultsDataFilters = state =>
  selectState(state).inspectionResultsDataFilters;
export const inspectionResultsQCDataFilters = state =>
  selectState(state).inspectionResultsQCDataFilters;
export const inspectionResultsDataSortKey = state =>
  selectState(state).inspectionResultsDataSortKey;
export const selectFilteredInspectionResultss = createSelector(
  [selectInspectionResultsData, selectInspectionResultsFilters],
  (data, { searchText }) => {
    console.log('in selectFilteredInspectionResultss', data);
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);

export const selectFiIteredInspectionResultData = createSelector(
  [inspectionResultsData, inspectionResultsDataFilters, inspectionResultsQCDataFilters],
  (data, { toDate, fromDate }, { toDate: toQcDate, fromDate: fromQcDate }) => {
    const filteredAQLList = data.aqlResults.filter(({ inspectionDate }) => {
      let inspectionDateFormatted = inspectionDate.split('T')[0];
      const inspStartDate = new Date(inspectionDateFormatted).getTime();
      const fromDateStamp = new Date(fromDate).getTime();
      const toDateStamp = new Date(toDate).getTime();
      if (!fromDateStamp && !toDateStamp) return true;
      else if (fromDateStamp && toDateStamp) {
        if (inspStartDate >= fromDateStamp && inspStartDate <= toDateStamp) return true;
        else return false;
      } else if (fromDateStamp && !toDateStamp) {
        if (inspStartDate >= fromDateStamp) return true;
        else return false;
      } else if (!fromDateStamp && toDateStamp) {
        if (inspStartDate <= toDateStamp) return true;
        else return false;
      }
    });
    const filteredQCList = data.qcResults.filter(({ inspectionDate }) => {
      let inspectionDateFormatted = inspectionDate.split('T')[0];
      const inspStartDate = new Date(inspectionDateFormatted).getTime();
      const fromDateStamp = new Date(fromQcDate).getTime();
      const toDateStamp = new Date(toQcDate).getTime();
      if (!fromDateStamp && !toDateStamp) return true;
      else if (fromDateStamp && toDateStamp) {
        if (inspStartDate >= fromDateStamp && inspStartDate <= toDateStamp) return true;
        else return false;
      } else if (fromDateStamp && !toDateStamp) {
        if (inspStartDate >= fromDateStamp) return true;
        else return false;
      } else if (!fromDateStamp && toDateStamp) {
        if (inspStartDate <= toDateStamp) return true;
        else return false;
      }
    });
    return {
      ...data,
      aqlResults: filteredAQLList,
      qcResults: filteredQCList,
    };
  },
);
